<template>
  <div class="profiles__component profiles-settings">
    <div class="profiles__component-content">
      <el-row class="profiles__component-row">
        <r-text type="caption" style="margin-bottom:4px">
          {{ $t("ps:profile-name") }}
        </r-text>
        <div class="profiles-settings__rename-block">
          <el-input
            class="r-input profiles-settings__profile-rename-input"
            size="mini"
            @focus="inputFocus"
            @blur="inputBlur"
            :placeholder="`${$t('ps:profile-name:placeholder')}`"
            v-model="profileName"
          />
          <div
            class="ds-editor__rename-block__controls"
            v-if="profileName !== initialProfileName"
          >
            <el-button
              @click="renameProfile"
              class="r-button icon-button"
              circle
              icon="el-icon-check"
              size="mini"
              type="primary"
              :disabled="!profileName || !profileName.trim()"
            />
            <el-button
              @click="cancelRename"
              class="r-button icon-button"
              circle
              icon="el-icon-close"
              size="mini"
              type="primary"
            />
          </div>
        </div>
      </el-row>
      <profile-constructor />
    </div>
  </div>
</template>

<script>
import profileConstructor from "./profiles-constructor.vue";
import { notifyFactory } from "@/utils";

export default {
  components: {
    profileConstructor
  },
  data() {
    return {
      renameInput: null,

      profile: "",
      profileName: "",
      initialProfileName: ""
    };
  },
  computed: {
    profileId() {
      return this.$store.state.profiles.profileConstructor.profileId;
    },
    profilesList() {
      return this.$store.state.profiles.profilesTree;
    }
  },
  methods: {
    inputFocus() {
      this.renameInput = document
        .querySelector(".profiles-settings__profile-rename-input")
        .querySelector("input");

      this.renameInput.addEventListener("keydown", this.inputOnKeyDown);
    },
    inputBlur() {
      this.renameInput.removeEventListener("keydown", this.inputOnKeyDown);
    },
    inputOnKeyDown(e) {
      e.stopPropagation();

      if (e.key === "Enter") {
        this.renameProfile();
        this.renameInput.blur();
      }
      if (e.key === "Escape") {
        this.cancelRename();
        this.renameInput.blur();
      }
    },
    cancelRename() {
      this.profileName = this.initialProfileName;
    },
    async renameProfile() {
      const options = {
        url: "user/profile?",
        data: { id: this.profileId, name: this.profileName }
      };

      try {
        await this.$store.dispatch("POST_REQUEST", options);
        let user = await this.$store.dispatch("REQUEST", { url: `user` });
        this.$store.commit("SET_PROFILES_TREE", user.data.user_profiles);
        this.initialProfileName = this.profileName;
        const title = this.$t("profiles-settings:notify:success-title");
        const message = this.$t("profiles-settings:notify:success");
        this.$notify(notifyFactory("info", title, message));
      } catch (e) {
        console.log(e);
      }
    }
  },
  mounted() {
    this.profile = this.profilesList.find(e => e.id === this.profileId);
    this.profileName = this.profile.name;
    this.initialProfileName = this.profile.name;
  }
};
</script>

<style lang="scss">
.profiles-settings {
  .profiles__component {
    &-content {
      min-width: 500px;
      max-width: 90vw;
      width: 800px;
      height: 560px;
    }
  }
  &__rename-block {
    display: flex;
    align-items: center;
  }
}
</style>

<i18n>
{
  "ru": {
    "ps:profile-name": "Название профиля",
    "ps:profile-name:placeholder": "Название",
    "ps:profile-rename": "Переименовать профиль",
    "ps:profile-rename:save": "Сохранить",
    "ps:profile-rename:cancel": "Отменить",

    "profiles-settings:notify:success-title": "Уведомление",
    "profiles-settings:notify:success": "Профиль успешно переименован!"
  },
  "en": {
    "ps:profile-name": "Profile name",
    "ps:profile-name:placeholder": "Name",
    "ps:profile-rename": "Rename profile",
    "ps:profile-rename:save": "Save",
    "ps:profile-rename:cancel": "Cancel",

    "profiles-settings:notify:success-title": "Notification",
    "profiles-settings:notify:success": "Profile successfully rename!"
  }
}
</i18n>
